module.exports = __webpack_public_path__ + "img/asteroid.be5030ca.webp";